// [FROST BUDDY] DST-aware correction for the "FB - Collection Notify" heading.
//
// The section server-renders a best-guess heading using a fixed EST offset. This recomputes the
// TRUE 9:00am America/New_York cutoff (DST-aware, matching blocks/_fb-drop-countdown.liquid) and
// sets the correct text: the launch teaser before the cutoff, the default heading after. This
// corrects both the ~1hr EDT-summer window and any page-cache lag on the exact cutover.

/**
 * Convert an Eastern wall-clock time to a UTC epoch (ms), accounting for DST.
 * (Copied verbatim from the drop countdown so the two stay in lockstep.)
 */
function easternWallClockToUtc(year, month, day, hour, minute) {
  const naive = Date.UTC(year, month - 1, day, hour, minute);
  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hourCycle: 'h23',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
  const parts = Object.fromEntries(fmt.formatToParts(new Date(naive)).map((p) => [p.type, p.value]));
  const shown = Date.UTC(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour),
    Number(parts.minute)
  );
  return naive + (naive - shown);
}

function correctHeading(heading) {
  const raw = heading.dataset.fbLaunchDate;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw || '')) return;
  const [year, month, day] = raw.split('-').map(Number);
  const cutoff = easternWallClockToUtc(year, month, day, 9, 0);
  if (Number.isNaN(cutoff)) return;

  const upcoming = Date.now() < cutoff;
  const text = upcoming ? heading.dataset.fbLaunchHeading : heading.dataset.fbDefaultHeading;
  if (typeof text === 'string' && text.length && heading.textContent !== text) {
    heading.textContent = text;
  }
}

function run() {
  document
    .querySelectorAll('.fb-collection-notify__heading[data-fb-launch-date]')
    .forEach(correctHeading);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', run);
} else {
  run();
}
// Re-run when the section is re-rendered in the theme editor.
document.addEventListener('shopify:section:load', run);
